import logo from './logo.svg';
import {Route,Switch} from 'react-router-dom'
import './App.css';
import Home from './Home';
import Whitepaper from './Whitepaper'
import Discuccion from './Discuccion'
import Coinburn from './Coinburn'
import launch from './Launch';
import Earned from './Earn';
import Presale from './Presale';
import How from './How';
import Dapp from './Dapp/Dapp'
import Browser from './Browser/browser'
import LockToken from './Browser/lockToken'
import LockLiquidity from './Browser/lockLiquidity'

import '../src/Fonts/Minecraft.ttf'; 


function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/" exact component={Home} />
        {/* <Route path="/coin-burn" exact component={Coinburn} /> */}
        {/* <Route path="/launch" exact component={launch} /> */}
        <Route path="/White-paper" exact component={Discuccion} />
        <Route path="/wall-of-fame" exact component={Whitepaper} />
        <Route path="/dashboard" exact component={Dapp} />
        <Route path="/browser" exact component={Browser} />
        <Route path="/how" exact component={How} />
        <Route path="/lock-token" exact component={LockToken} />
        <Route path="/lock-lp-token" exact component={LockLiquidity} />

      </Switch>
    </div>
  );
}

export default App;
